<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="投稿管理" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <a-button v-if="getState(editData.djzt) === 0" :loading="loading || saving" type="danger" @click="revoke">撤销</a-button>
            </template>
            <a-divider></a-divider>
            <a-layout>
                <a-layout-content>
                    <a-spin :spinning="loading">
                        <a-form ref="form" class="fun-edit-form" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
                            <FGCollapsiblePanel title="基本信息">
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="投稿单编号">
                                            <a-input ref="djbh" v-model="editData.djbh" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="投稿类型">
                                            <a-input ref="tglx" v-model="editData.tglx" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12" v-if="editData.tglx === '主题征文'">
                                        <a-form-item label="主题名称">
                                            <a-input ref="ztmc" v-model="editData.ztmc" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="单位名称">
                                            <a-input ref="dwmc" v-model="editData.dwmc" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="单位编号">
                                            <a-input ref="dwbh" v-model="editData.dwbh" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="联系人">
                                            <a-input ref="lxr" v-model="editData.lxr" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="联系方式">
                                            <a-input ref="lxfs" v-model="editData.lxfs" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="QQ">
                                            <a-input ref="qq" v-model="editData.qq" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="录入人">
                                            <a-input ref="lrr" v-model="editData.lrr" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="录入部门">
                                            <a-input ref="lrbmmc" v-model="editData.lrbmmc" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="录入日期">
                                            <a-input ref="lrrq" v-model="editData.lrrq" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item label="关键词" :label-col="{ span: 3 }" :wrapper-col="{ span: 18 }">
                                            <a-input ref="gjc" v-model="editData.gjc" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item label="简介" :label-col="{ span: 3 }" :wrapper-col="{ span: 18 }">
                                            <a-textarea ref="jj" v-model="editData.jj" :auto-size="{ minRows: 5, maxRows: 10 }" disabled class="view" />
                                        </a-form-item>
                                    </a-col>

                                    <a-col :span="24">
                                        <a-form-item label="备注" :label-col="{ span: 3 }" :wrapper-col="{ span: 18 }">
                                            <a-textarea ref="bz" v-model="editData.bz" :auto-size="{ minRows: 5, maxRows: 10 }" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                        </a-form>
                    </a-spin>
                    <!-- 流程跟踪组件 -->
                    <OperLog ref="operlog" :operLogProps="operLogProps"></OperLog>
                </a-layout-content>
                <a-layout-sider class="region-attach-uploadpanel">
                    <AttachDownload :attachCfg.sync="attachCfg" />
                </a-layout-sider>
            </a-layout>
        </a-page-header>
    </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");
export default {
    name: "TgsqForm",
    components: {},
    props: ["dataId", "submited", "componentName"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            // 流程跟踪参数
            operLogProps: {
                visible: false,
                billid: null
            }
        };
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getToken"]),
        subTitle() {
            return "查看";
        },
        // 是否显示编辑界面
        editIsVisible: {
            get() {
                return this.componentName;
            },
            set(newVal) {
                this.$emit("update:componentName", newVal);
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        // 当前编辑记录id
        editSubmited: {
            get() {
                return this.submited;
            },
            set(newVal) {
                this.$emit("update:submited", newVal);
            }
        },
        loading() {
            return this.editDataLoading;
        },
        //附件参数
        attachCfg() {
            return {
                visible: false,
                fktable: "DW_TGSQ",
                fkfield: "ID",
                fkvalue: this.editData.id,
                attachsource: "TG1002"
            };
        }
    },
    activated() {
        // 修改，加载数据
        this.loadData();
    },
    methods: {
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxdw/tggl/tggl/getDetail",
                    {
                        id: this.editDataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                            this.initOperLog();
                        } else {
                            // 加载的数据不存在则提示错误并返回列表
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = "TgsqBrowse"));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则返回列表
                        this.editIsVisible = "TgsqBrowse";
                    }
                });
        },
        // 返回列表
        onBack() {
            this.editIsVisible = "TgsqBrowse";
        },
        getState(state) {
            if (state === "制定" || state === "撤销" || state === "否决") {
                return 1;
            }
            if (state === "提交") {
                return 0;
            }
        },
        revoke() {
            this.$FG_message.confirm("P0000", "撤销").then((type) => {
                if (type === "ok") {
                    this.$FG_http
                        .post(
                            "./api/main/zxdw/tggl/tggl/revoke",
                            {
                                data: this.editData
                            },
                            {
                                showSuccess: true
                            }
                        )
                        .then(({ success, data, errMsg }) => {
                            if (success) {
                                // 设置当前行
                                this.editDataId = this.editData.id;
                                this.editIsVisible = "TgsqBrowse";
                            }
                        });
                }
            });
        },
        //加载操作日志
        initOperLog() {
            this.operLogProps.visible = true;
            this.operLogProps.billid = this.editData.id;
        }
    }
};
</script>
<style lang="scss" scoped>
.table-button {
    margin-right: 10px;
}
</style>
